import App from 'App';
import 'App.scss';
import ReactDOM from 'react-dom';
import 'tailwindcss/tailwind.css';

ReactDOM.render(<App />, document.getElementById('root'));
